import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

const mutation = gql`
  mutation duplicateSubMenu($id: Int) {
    duplicateSubMenu(id: $id) {
      status
      errorMessage
      result {
        id
      }
    }
  }
`;

// The caller (ItemList) refetches its own active getAllSubMenu query after this
// resolves, so we don't refetch here — the component's query variables include
// searchList, which a refetchQueries entry here wouldn't match.
export default function duplicateSubMenu(id, currentPage, menuId) {
  return async (_dispatch, _getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: { id },
      });

      if (data && data.duplicateSubMenu && data.duplicateSubMenu.status === 200) {
        toastr.success('Success', 'Sub menu duplicated successfully.');
        return data.duplicateSubMenu.result && data.duplicateSubMenu.result.id;
      } else {
        const errorMessage = (data && data.duplicateSubMenu && data.duplicateSubMenu.errorMessage) || 'Oops! Something went wrong.';
        toastr.error('Error!', errorMessage);
        return null;
      }
    } catch (err) {
      toastr.error('Error!', err.message || err);
      return null;
    }
  };
}
